var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 128,
    viewBox: "0 0 159 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67773 127.726H105.319V40.9414H7.67773V127.726Z",
    fill: "#97B1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6777 127.726H151.319V4.1875H53.6777V127.726Z",
    fill: "#97B1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 127.538H151.078V4H105V127.538Z",
    fill: "#648AEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 127.538H105.078V40.7539H59V127.538Z",
    fill: "#648AEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5225 40.8771H83.2992V20.9854H74.5225V40.8771Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 4.18774H159V0H46V4.18774Z",
    fill: "#648AEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5225 67.4181H37.2992V53.4443H28.5225V67.4181Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5225 123.314H37.2992V109.34H28.5225V123.314Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2408 72.9338C59.2408 73.0404 47.6967 73.1257 33.4606 73.1257C19.2193 73.1257 7.67773 73.0404 7.67773 72.9338C7.67773 72.8286 19.2193 72.7425 33.4606 72.7425C47.6967 72.7425 59.2408 72.8286 59.2408 72.9338Z",
    fill: "#FFFFFE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5225 95.3663H37.2992V81.3926H28.5225V95.3663Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2408 100.881C59.2408 100.988 47.6967 101.073 33.4606 101.073C19.2193 101.073 7.67773 100.988 7.67773 100.881C7.67773 100.776 19.2193 100.69 33.4606 100.69C47.6967 100.69 59.2408 100.776 59.2408 100.881Z",
    fill: "#FFFFFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1172 67.4181H77.8939V53.4443H69.1172V67.4181Z",
    fill: "#97B1F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 28.9737H125.777V15H117V28.9737Z",
    fill: "#97B1F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8647 67.4181H97.6414V53.4443H88.8647V67.4181Z",
    fill: "#97B1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.748 28.9737H145.524V15H136.748V28.9737Z",
    fill: "#97B1F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1172 94.63H77.8939V80.6562H69.1172V94.63Z",
    fill: "#97B1F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 56.1866H125.777V42.2129H117V56.1866Z",
    fill: "#97B1F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 108.974H125.777V95H117V108.974Z",
    fill: "#97B1F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8647 94.63H97.6414V80.6562H88.8647V94.63Z",
    fill: "#97B1F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.748 56.1866H145.524V42.2129H136.748V56.1866Z",
    fill: "#97B1F1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.748 108.974H145.524V95H136.748V108.974Z",
    fill: "#97B1F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1172 121.843H77.8939V107.869H69.1172V121.843Z",
    fill: "#97B1F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 83.3976H125.777V69.4238H117V83.3976Z",
    fill: "#97B1F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8647 121.843H97.6414V107.869H88.8647V121.843Z",
    fill: "#97B1F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.748 83.3976H145.524V69.4238H136.748V83.3976Z",
    fill: "#97B1F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.9418H113V38H0V40.9418Z",
    fill: "#648AEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIllustration);
export default __webpack_public_path__ + "static/media/building-illustration.8b9dc87b7b645cf6f6be2e5758207c4f.svg";
export { ForwardRef as ReactComponent };